import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import {
  SensitiveDataPolicySummariesLoader,
  SensitiveDataManager,
  SensitiveDataMaskingSettingsForm
} from '../../../components/sensitive-data'
import { css } from '@emotion/css'
import { sendDefaultEvent } from '../../../components/analytics'

function Bridge({ organizationID }) {
  sendDefaultEvent('sensitive.data.grid.view')

  return (
    <SensitiveDataPolicySummariesLoader organizationID={organizationID}>
      {({
        loading,
        refetch,
        sensitiveDataPolicySummaries,
        organizationRole
      }) => {
        return (
          <div>
            <div
              className={css`
                padding-bottom: 20px;
              `}
            >
              <SensitiveDataMaskingSettingsForm
                organizationID={organizationID}
                organizationRole={organizationRole}
                loadingRole={loading}
              />
            </div>
            <SensitiveDataManager
              organizationID={organizationID}
              organizationRole={organizationRole}
              rowData={sensitiveDataPolicySummaries}
              loading={loading}
              refetch={refetch}
            />
          </div>
        )
      }}
    </SensitiveDataPolicySummariesLoader>
  )
}

export const reactSensitiveDataGrid = createNgReactBridgeDirective(
  'reactSensitiveDataGrid',
  [],
  Bridge,
  ['organizationID']
)
